import React from "react";
import styled from "styled-components";
import ReactSlider from "rc-slider/lib/Slider";
import { formatCurrency } from "lib/format";
import "rc-slider/assets/index.css";

const Container = styled.div`
  padding: 0 4rem 2rem;
  width: 100%;
  max-width: ${(props) =>
    props.increments <= 8 ? `${props.increments * 10}rem` : "100%"};
  margin: 0 auto 3rem;

  @media (min-width: 992px) {
    padding: 0 2rem 2rem;
  }
`;

const Slider = styled(ReactSlider)`
  .rc-slider-rail {
    background-color: #828282;
  }

  .rc-slider-track {
    background-color: ${(props) =>
      props.isThreshold ? "#ff0000" : props.theme.palette.primary};
    height: 8px;
    margin-top: -2px;
  }

  .rc-slider-handle {
    z-index: 10;
    width: 5.4rem;
    height: 5.4rem;
    margin-top: -2.5rem;
    border-color: ${(props) => (props.isThreshold ? "#ff0000" : "#828282")};
    background: #fff url(/quiz/slider-handle.png) center center no-repeat;
    background-size: 60% auto;
    filter: ${(props) => (props.disabled ? "grayscale(100%)" : "none")};

    &:active,
    &:focus {
      box-shadow: 0 0 5px #828282;
    }
  }

  .rc-slider-dot {
    opacity: 0;
    bottom: -6px;
    margin-left: -10px;
    width: 20px;
    height: 20px;
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .rc-slider-mark {
    top: 20px;
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .rc-slider-mark-text {
    padding: 1.5rem 1rem 0;
    color: #828282;
    font-size: 1.6rem;
    white-space: nowrap;

    &::before {
      content: "";
      position: absolute;
      left: 50%;
      margin-left: -1px;
      top: 0;
      width: 2px;
      height: 15px;
      background-color: #828282;
    }
  }

  &.rc-slider-disabled {
    background-color: transparent;
  }
`;

const SliderComponent = (props) => {
  const marks = getSliderMarks(props);

  return (
    <Container
      increments={props.isBudget ? 100 : Math.round(props.max / props.step)}
    >
      <Slider {...props} marks={marks} isThreshold={props.isThreshold} />
    </Container>
  );
};

export default SliderComponent;

function getSliderMarks(props) {
  const min = props.min || 0;
  const max = props.max;

  const marks = props.isBudget ? Math.floor((max - min) / 5) : props.step;

  const output = {};

  for (let i = min; i <= max; i += marks) {
    let value = i + marks > max ? max : i;

    if (props.isBudget) {
      output[value] = formatCurrency(value, props.country);
    } else {
      output[value] = " ";
    }
  }

  if (Object.keys(output).length >= 15) return {};

  return output;
}
